import React from "react";

// Pure CSS starry sky overlay. Pre-renders many stars at randomized positions.
function makeStars(count) {
    const stars = [];
    for (let i = 0; i < count; i++) {
        const size = Math.random() < 0.85 ? 1 : Math.random() < 0.5 ? 2 : 3;
        stars.push({
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            size,
            duration: 3 + Math.random() * 5,
            delay: Math.random() * 5,
        });
    }
    return stars;
}

const STARS = makeStars(160);

export default function StarryBackground() {
    return (
        <div className="starry-bg" data-testid="starry-bg">
            {STARS.map((s, i) => (
                <span
                    key={i}
                    className="star"
                    style={{
                        top: s.top,
                        left: s.left,
                        width: `${s.size}px`,
                        height: `${s.size}px`,
                        "--duration": `${s.duration}s`,
                        "--delay": `${s.delay}s`,
                    }}
                />
            ))}
            <span className="shooting-star" style={{ top: "20%", left: "10%", "--delay": "2s" }} />
            <span className="shooting-star" style={{ top: "60%", left: "40%", "--delay": "6s" }} />
        </div>
    );
}
